<template>
    <div class="searchCombo">
        <topNav :title="title"></topNav>
       
        <commonInput @commitCarNum="searchCombo" :btntxt="'查询套餐'"></commonInput>
    </div>
</template>
<script>
import topNav from "@/components/topnav/topnav"
import {Toast,Dialog} from 'vant';
import commonInput from "@/components/common/commonInput"
export default {
    name: 'searchCombo',
    components:{
        topNav,
        commonInput
    },
    data() {
        return {
            title:"查询套餐",

        }
    },
    mounted(){
        // this.couponValue = sessionStorage.getItem("coupon_value");
        // this.couponValidhours = sessionStorage.getItem("coupon_validhours");
        // this.couponType = this.getCouponType(sessionStorage.getItem("coupon_type"));
    },
    methods:{
        searchCombo(carNum){//查询套餐
            this.commonUtil.setCookie("carNum2",carNum,30)
            this.$router.push({
                name:"parkingOption",
                query:{
                    carNum
                }
            });
        },
    },
    created(){
    },
    watch:{
    }


}
</script>
<style>
.searchCombo{
    background: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/recharge/searchCombo.vue